<template>
    <PopupWrapper
        title="歡迎您的加入，<br />啟動之前需要請您先填寫資料"
        :close="isCloseable"
        @close="$emit('close')"
        @confirm="onValidateForm"
    >
        <InputWrapper
            v-model="data[input.fieldName]"
            v-for="(input, i) in formInputs"
            :key="`input${i}`"
            :ref="`input${i}`"
            :label="input.label"
            :placeholder="input.placeholder"
            :rules="input.rules"
        />
        <template v-slot:hint>
            *遊戲暱稱將用於玩家參與遊戲時使用，玩家可在此頁自行修改暱稱
        </template>
    </PopupWrapper>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import PopupWrapper from '@/components/Wrapper/PopupWrapper.vue';
import InputWrapper from '@/components/Wrapper/InputWrapper.vue';
import Sdk from '@/sdk';

export default {
    components: { PopupWrapper, InputWrapper },
    data() {
        return {
            formInputs: [
                {
                    label: '遊戲暱稱',
                    fieldName: 'name',
                    placeholder: '請輸入遊戲暱稱',
                    rules: {
                        required: true,
                    },
                },
            ],
            data: {
                name: '',
            },
        };
    },
    computed: {
        ...mapState({
            defaultName: 'defaultName',
            user: 'user',
            isCloseable: (state) => !!state.user?.name,
        }),
    },
    methods: {
        init() {
            if (!_.isEmpty(this.user.name)) this.$set(this.data, 'name', this.user.name);

            if (!_.isEmpty(this.defaultName)) {
                const config = _.find(this.formInputs, ['fieldName', 'name']);
                config.placeholder = this.defaultName;
            }
        },
        async onValidateForm() {
            // const LENGTH = this.formInputs.length;
            // let VALIDATE = true;
            // for (let i = 0; i < LENGTH; i += 1) {
            //     const REF = this.$refs[`input${i}`][0];
            //     if (!REF.validate() && VALIDATE) VALIDATE = false;
            // }

            // 20220413 沒填暱稱需預設送出line名稱
            // 因 InputWrapper無法在這裡即時更新value故棄用原有驗證邏輯
            if (_.isEmpty(this.data.name)) this.data.name = this.defaultName;
            await Sdk.updateUserProfile({
                email: this.data.email,
                name: this.data.name,
                phone: this.data.phone,
            });
            this.$emit('close');
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        defaultName() {
            this.init();
        },
    },
};
</script>
